(() => {
  if (!location.pathname.startsWith('/pages/kp-account')) return;

  const storeOrders = (r) => {
    const m = (r.textContent || '').match(/(\d+)\s*Total Orders/i);
    if (!m) return;
    try {
      const prev = localStorage.getItem('nc_kp_orders');
      localStorage.setItem('nc_kp_orders', m[1]);
      if (prev !== m[1]) window.dispatchEvent(new Event('nc-kp-orders'));
    } catch (e) {}
  };

  const fix = (r) => {
    storeOrders(r);
    r.querySelectorAll('[data-kp-target="i18n.order.fieldOrderId"]').forEach(
      (el) => {
        el.closest('div.flex.items-center.justify-between')?.remove();
      },
    );
    r.querySelectorAll('[data-kp-target="i18n.order.fieldOrderName"]').forEach(
      (el) => {
        if (el.textContent.trim() === 'Order Name')
          el.textContent = 'Order Number';
      },
    );
  };

  const i = setInterval(() => {
    const r = document.querySelector('#MainContent')?.shadowRoot;
    if (!r) return;
    clearInterval(i);
    fix(r);
    new MutationObserver(() => fix(r)).observe(r, {
      childList: true,
      subtree: true,
    });
  }, 100);

  setTimeout(() => clearInterval(i), 15000);
})();

(() => {
  if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined')
    return;

  const mobile = matchMedia('(max-width:749px)');
  const PICKERS = 'variant-selects, product-option-selects';
  const cache = new Map();
  let lockY = null;

  const pInfo = (el) => el?.closest('product-info');
  const parse = (html) => new DOMParser().parseFromString(html, 'text/html');
  const prefetch = (url) =>
    url &&
    !cache.has(url) &&
    fetch(url)
      .then((r) => r.text())
      .then((t) => cache.set(url, t))
      .catch(() => {});

  const setBusy = (info, on) => {
    if (!info) return;
    info.toggleAttribute('data-nc-variant-busy', on);
    info.querySelectorAll(PICKERS).forEach((p) => {
      p.toggleAttribute('aria-disabled', on);
      p.querySelectorAll('input, select').forEach((i) =>
        i.toggleAttribute('disabled', on),
      );
    });
  };

  const restore = () => {
    if (lockY == null) return;
    try {
      window.scrollTo({ top: lockY, behavior: 'instant' });
    } catch (e) {
      window.scrollTo(0, lockY);
    }
  };

  const finish = (info) => {
    restore();
    requestAnimationFrame(restore);
    lockY = null;
    setBusy(info, false);
  };

  document.addEventListener(
    'change',
    (e) => {
      const t = e.target;
      if (t.type !== 'radio') return;
      const picker = t.closest(PICKERS);
      if (!picker) return;
      const info = pInfo(picker);
      if (!info) return;
      if (info.hasAttribute('data-nc-variant-busy')) {
        e.preventDefault();
        e.stopImmediatePropagation();
        return;
      }
      if (picker.matches('product-option-selects')) {
        const url = t.dataset.productUrl;
        if (url && url !== info.dataset.url) {
          publish(PUB_SUB_EVENTS.optionValueSelectionChange, {
            data: { event: e, target: t, selectedOptionValues: [] },
          });
        }
      }
      setBusy(info, true);
    },
    true,
  );

  document.addEventListener(
    'pointerenter',
    (e) =>
      prefetch(e.target.closest?.('[data-product-url]')?.dataset.productUrl),
    true,
  );

  subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, ({ data: { event } }) => {
    const t = event.target;
    if (!pInfo(t)) return;
    if (mobile.matches || t.closest('product-option-selects')) lockY = window.scrollY;
  });

  subscribe(PUB_SUB_EVENTS.variantChange, ({ data: { sectionId } }) => {
    finish(
      document.querySelector(
        `product-info[data-section="${sectionId}"],product-info[data-original-section="${sectionId}"]`,
      ),
    );
  });

  document.addEventListener(
    'product-info:loaded',
    (e) => finish(pInfo(e.target)),
    true,
  );

  if (typeof HTMLUpdateUtility !== 'undefined' && !HTMLUpdateUtility._nc) {
    const { setInnerHTML } = HTMLUpdateUtility;
    HTMLUpdateUtility.viewTransition = function (old, neu, pre, post) {
      pre?.forEach((fn) => fn(neu));
      const wrap = document.createElement('div');
      setInnerHTML(wrap, neu.outerHTML);
      const node = wrap.firstChild;
      const key = Date.now();
      old.querySelectorAll('[id], [form]').forEach((el) => {
        if (el.id) el.id = `${el.id}-${key}`;
        if (el.form)
          el.setAttribute('form', `${el.form.getAttribute('id')}-${key}`);
      });
      const y = mobile.matches ? null : lockY;
      old.replaceWith(node);
      post?.forEach((fn) => fn(node));
      if (y == null) return;
      lockY = y;
      restore();
      requestAnimationFrame(() => {
        lockY = y;
        restore();
        lockY = null;
      });
    };
    HTMLUpdateUtility._nc = 1;
  }

  const patch = (tag, fn) =>
    customElements.whenDefined?.(tag)?.then(() => {
      const proto = customElements.get(tag)?.prototype;
      if (proto && !proto._nc) {
        fn(proto);
        proto._nc = 1;
      }
    });

  patch('media-gallery', (proto) => {
    const orig = proto.revealMedia;
    proto.revealMedia = function (...args) {
      orig.apply(this, args);
      if (mobile.matches && lockY != null) restore();
    };
  });

  patch('product-info', (proto) => {
    proto.handleOptionValueChange = function ({
      data: { event, target, selectedOptionValues },
    }) {
      if (!this.contains(event.target)) return;
      this.resetProductFormState();
      const url =
        target.dataset.productUrl || this.pendingRequestUrl || this.dataset.url;
      this.pendingRequestUrl = url;
      const swap = this.dataset.url !== url;
      const po = target.closest('product-option-selects');
      const full = swap && !po && this.dataset.updateUrl === 'true';
      this.renderProductInfo({
        requestUrl:
          po && swap
            ? url
            : this.buildRequestUrlWithParams(url, selectedOptionValues, full),
        callback: swap
          ? this.handleSwapProduct(url, !!(po || full))
          : this.handleUpdateProductInfo(url),
      });
    };

    proto.renderProductInfo = function ({ requestUrl, callback }) {
      this.abortController?.abort();
      this.abortController = new AbortController();
      const run = (text) => {
        this.pendingRequestUrl = null;
        callback(parse(text));
      };
      const hit = cache.get(requestUrl);
      if (hit) return run(hit);
      fetch(requestUrl, { signal: this.abortController.signal })
        .then((r) => r.text())
        .then((text) => {
          cache.set(requestUrl, text);
          run(text);
        })
        .catch((e) => {
          if (e.name !== 'AbortError') console.error(e);
          setBusy(this, false);
        });
    };

    const origUpdateURL = proto.updateURL;
    proto.updateURL = function (...args) {
      const y = lockY;
      origUpdateURL.apply(this, args);
      if (y == null || window.scrollY === y) return;
      lockY = y;
      restore();
    };

    const info = document.querySelector('product-info[id^="MainProduct"]');
    if (!info) return;
    const section = info.dataset.originalSection || info.dataset.section;
    info.querySelectorAll('[data-product-url]').forEach((el) => {
      const url = el.dataset.productUrl;
      if (!url || url === info.dataset.url) return;
      prefetch(
        el.closest('product-option-selects')
          ? url
          : `${url}?section_id=${section}`,
      );
    });
  });
})();
